import { useEffect } from "react";
import { useDispatch, useSelector, } from "react-redux";
import LocalAgentsContact from "components/Forms/Contact/LocalAgentsModal";
import { useRouter } from 'next/navigation'
import { modalSet } from "_slices/view";
import { checkLoggedIn, getUserDetails } from "context/context";


type Props = {
  id: number, 
  address: object, 
  docType: string, 
  name: string, 
  agents: [],
  local_agents: LocalAgents[],
}

type LocalAgents = {
  id: number,
  local_properties: {
    user_ids: []
  }[],
}
type AgentList = {
  company_id: number,
  user_id: number;
}
type state = {
  view: {
    modal: any
  }
}

const LocalAgentsForm = (props) => {

  const reduxDispatch = useDispatch();
  const modal = useSelector((state: state) => state.view.modal);
  const loggedIn = checkLoggedIn()
  const userDetails = getUserDetails();
  const { id, address, docType, name, agents = [], local_agents = [] }: Props = props;
  const router = useRouter();
  const agentList: AgentList[] = [];
  const agentDedupe = {};

  local_agents.forEach((a) => {
    const company_id = a.id;
    a?.local_properties?.slice(0, 1).forEach((p) => {
      p.user_ids.forEach((u) => {
        const user_id = Number(u);
        const key = `${company_id}:${user_id}`;
        if (!agentDedupe[key]) {
          agentDedupe[key] = 1;
          agentList.push({ company_id, user_id });
        }
      })
    })
  })

  let property = {
    type: docType,
    id: id,
    name: name,
    address: address,
  };

  const closeModal = () => {
    reduxDispatch(
      modalSet({
        visible: false,
        router
      })
    );
    reduxDispatch({ type: "contactFormReset" });
    const myBody = document.body;
    if(myBody && myBody.classList.contains('ContactForm__Body--open')) {
      myBody.classList.remove('ContactForm__Body--open')
    }
  };

  useEffect(() => {
  }, [loggedIn, userDetails]);


  return (
    <LocalAgentsContact
      user={userDetails}
      type={docType}
      property={property}
      agentList={agentList}
      id="contactUs"
      form={[]}
      onSubmit={(e) => {
        e.preventDefault();
      }}
      modal={{
        id: "localAgentsContact",
        isOpen: modal.type === "localAgentsContact" && modal.visible,
        label: `Send a message`,
        closeModal: closeModal,
        onClick: (e) => {
          e.stopPropagation();
        },
      }}
    />
  );
};

export default LocalAgentsForm;
